import React from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import {
  FaStar,
  FaStarHalfAlt,
  FaRegStar,
} from "react-icons/fa";

import "swiper/css";


const ReviewsSection = () => {


  const reviews = [

    {
      name: "Miss. Priya Sharma",
      rating: 5,
      text:
        "Booked a Mumbai Airport taxi with Shreesha Tours & Travels. The driver arrived on time and the journey was very smooth and safe.",
    },

    {
      name: "Mr. Amit Patil",
      rating: 5,
      text:
        "Best taxi service in Mumbai for local and outstation trips. Affordable pricing, professional drivers, and excellent customer support.",
    },

    {
      name: "Miss. Sneha Kulkarni",
      rating: 5,
      text:
        "Very comfortable ride experience. The cab was neat and the driver was experienced. I will definitely use this service again.",
    },

    {
      name: "Mr. Rahul Verma",
      rating: 5,
      text:
        "Booked an Innova Crysta for our family trip. The vehicle was clean, comfortable, and the service was excellent.",
    },

    {
      name: "Mrs. Kavita Joshi",
      rating: 4.5,
      text:
        "Reliable outstation cab service with polite drivers. Booking was easy and the entire journey was hassle-free.",
    },

    {
      name: "Mr. Rohan Mehta",
      rating: 5,
      text:
        "Excellent experience with Shreesha Tours & Travels. Safe driving, comfortable cars, and reasonable pricing.",
    },

  ];





  const getInitials = (name) => {

    return name
      .replace("Mr.", "")
      .replace("Mrs.", "")
      .replace("Miss.", "")
      .trim()
      .split(" ")
      .map((word) => word[0])
      .join("")
      .substring(0,2)
      .toUpperCase();

  };





  const renderStars = (rating) => {

    let stars = [];


    for(let i = 1; i <= 5; i++){


      if(i <= rating){

        stars.push(
          <FaStar
            key={i}
            className="star-icon"
          />
        );

      }


      else if(i - 0.5 === rating){

        stars.push(
          <FaStarHalfAlt
            key={i}
            className="star-icon"
          />
        );

      }


      else{

        stars.push(
          <FaRegStar
            key={i}
            className="star-icon"
          />
        );

      }

    }


    return stars;

  };






  return (

    <section className="reviews-section">


      <div className="reviews-container">



        <div className="reviews-header">

          <span className="text-white">
            Customer Reviews
          </span>


          <h2>
            Thousands of happy travelers trust Shreesha Tours & Travels
            for airport transfers, outstation cabs, corporate travel,
            pilgrimage tours, family trips, and one-way taxi services.
          </h2>

        </div>






        <Swiper

          modules={[Autoplay]}

          spaceBetween={25}

          slidesPerView={3}

          loop={true}


          autoplay={{
            delay:3000,
            disableOnInteraction:false,
          }}



          breakpoints={{

            0:{
              slidesPerView:1,
            },


            768:{
              slidesPerView:2,
            },


            1024:{
              slidesPerView:3,
            }

          }}



          className="reviews-slider"


        >



          {
            reviews.map((review,index)=>(


              <SwiperSlide key={index}>


                <div className="review-card">



                  <div className="review-stars">

                    {
                      renderStars(review.rating)
                    }

                  </div>





                  <p>
                    "{review.text}"
                  </p>






                  <div className="customer-info">


                    <div className="profile-circle">

                      {
                        getInitials(review.name)
                      }

                    </div>





                    <div>


                      <h4>
                        {review.name}
                      </h4>



                      <span>
                        Verified Customer
                      </span>


                    </div>


                  </div>




                </div>



              </SwiperSlide>


            ))
          }



        </Swiper>





      </div>


    </section>

  );

};


export default ReviewsSection;